import Vue from "@/main";
import store from "@/store/store.js"
import { connection } from "./jsstore_con";
import chatContact from "@/http/requests/chatContact";
import { CustomerService } from "@/db/customer_service";
import { CustomerGroupService } from "./customerGroup_service";
import { CustomerChatService } from "@/db/customerChat_service";

(function(){
    function parseDotNotation( str, val, obj ){
            let currentObj = obj,
                keys = str.split("."), i, l = keys.length - 1, key;
            
            if (keys.length > 1) {
                for (i = 0; i < l; ++i) {
                    key = keys[i];
                    currentObj[key] = currentObj[key] || {};
                    currentObj = currentObj[key];
                }
                currentObj[keys[i]] = val;
                delete obj[str];
            }
    }
    Object.expand = function( obj ) {
        for (let key1 in obj) {
            for (let key in obj[key1]) {
                parseDotNotation(key, obj[key1][key], obj[key1]);
                if (key === 'is_favorite') {
                    obj[key1].customer = {};
                    obj[key1].customer.is_favorite = obj[key1][key];
                    delete obj[key1].is_favorite;
                }
            }
        }
        return obj;
    };
})();

export class ChatTicketService {
    constructor() {
        this.tableName = "ChatTickets";
        this.cgService = new CustomerGroupService();
    }

    async getChatTicketsByTab(conditions, limit, newCondition = null, groupCondition = null, oldestFirst = 0, oldestPriority = 0, skip = 0) {
        let ordination = [];

        if (Number(oldestFirst) && Number(oldestPriority)) {
            ordination.push(...[
                {
                    by: 'ChatTickets.createdAt',
                    type: 'asc',
                },
                {
                    by: 'ChatTickets.priority',
                    type: 'desc',
                }
            ]);
        } else if (Number(oldestFirst)) {
            ordination.push({
                by: 'ChatTickets.createdAt',
                type: 'asc',
            });
        } else if (Number(oldestPriority)) {
            ordination.push({
                by: 'ChatTickets.priority',
                type: 'desc',
            });
        } else {
            ordination.push({
                by: 'ChatTickets.last_msg',
                type: 'desc',
            });
        }

        ordination.push({
            by: 'Customer.is_favorite',
            type: 'desc',
        });

        let query = {
            from: this.tableName,
            where: conditions,
            join: [{
                with: 'Customer',
                type: 'inner',
                on: "ChatTickets.customer_id = Customer.id",
                as: {
                    'id': 'customer.id',
                    'name': 'customer.name',
                    'phone_number': 'customer.phone_number',
                    'image': 'customer.image',
                    'is_blacklisted': 'customer.is_blacklisted',
                    'is_blacklisted_campaign': 'customer.is_blacklisted_campaign',
                    'open_field': 'customer.open_field',
                    'document_register': 'customer.document_register',
                    'address': 'customer.address',
                    'group_of_customer': 'customer.group_of_customer'
                }
            }],
            order: ordination,
            limit: limit,
            skip: skip,
            groupBy: ['customer_id', 'instance_id']
        }

        if (newCondition) {
            query.join[0].where = newCondition;
        }

        if (groupCondition) {
            query.join[1] = this.cgService.getJoin();
            query.join[1].where = groupCondition;
        }

        if (Number(oldestFirst)) {
            query.order.unshift({by: 'ChatTickets.customer_id', type: 'asc'});
        }

        let selection = await connection.select(JSON.parse(JSON.stringify(query)));
        if (groupCondition && query.join[1]) {
          query.join.splice(1, 1);
        }

        const currentPickable = selection.find(item => item.pickableInboxChat);
        if (
            Number(store.state.settings.settings.older_inbox_chats_obligatorie_in_first) &&
            store.state.chatContact.chatTab === 'inbox' &&
            selection.length > 0 &&
            Number(oldestFirst) &&
            currentPickable
        ) {
            if (Number(oldestPriority)) {
                const priorityChats = selection.filter(item => item.priority).sort((sortA, sortB) => sortB.priority - sortA.priority);
                if (priorityChats.length > 0 && currentPickable.id !== priorityChats[0].id) {
                    const currentPickableIndex = selection.findIndex(item => item.id === currentPickable.id);
                    const priorityIndex = selection.findIndex(item => item.id === priorityChats[0].id);
    
                    if (![currentPickableIndex, priorityIndex].includes(-1)) {
                        selection[currentPickableIndex].pickableInboxChat = false;
                        selection[priorityIndex].pickableInboxChat = true;
    
                        return Object.expand(selection);
                    }
                }
            } else if (!selection[0].pickableInboxChat && store.getters["instance/chosenInstanceIds"].length > 1) {
                selection.find(item => item.id === currentPickable.id).pickableInboxChat = !currentPickable;
                selection[0].pickableInboxChat = true;

                return Object.expand(selection);
            }
        }

        if (!currentPickable && !newCondition && selection.length > 0) {
            selection[0].pickableInboxChat = true;
        }

        return Object.expand(selection);
    }

    async countChatTicketsByTab(conditions){
        return await connection.count({
            from: this.tableName,
            where: conditions,
            groupBy: ['customer_id', 'instance_id'],
            join: {
                with: 'Customer',
                type: 'inner',
                on: "ChatTickets.customer_id = Customer.id",
                as: {
                    'id': 'customer.id',
                    'name': 'customer.name',
                    'phone_number': 'customer.phone_number',
                    'image': 'customer.image',
                    'is_blacklisted': 'customer.is_blacklisted',
                    'open_field': 'customer.open_field',
                    'address': 'customer.address',
                },
            },
        })
    }
    
    async removeAndInsert(values, socket = false) {
        for (const item of values) {
            if ( store.getters["instance/chosenInstanceIds"].includes(item.instance_id) ) {
                if ( socket ){
                    let chats = await connection.select({
                        from: this.tableName,
                        where: {
                            customer_id: item.customer_id,
                            instance_id: item.instance_id
                        }
                    });

                    chats.forEach((item) => {
                        Vue.$events.fire('SumOfTickets', {type: 'removed', data: item})
                    })
                }

                await connection.remove({
                    from: this.tableName,
                    where: {
                        customer_id: item.customer_id,
                        instance_id: item.instance_id
                    }
                })

                if (item.inbox) {
                    store.dispatch('chatContact/setInboxMessagesStatus', 'unseen');
                }
            }
        }

        await this.insert(values, socket)
    }

    async insert(values, socket = false, firstLoad = false) {
        if (values[0] !== undefined && !store.getters["instance/chosenInstanceIds"].includes(values[0].instance_id)) {
            return;
        }

        const cService = new CustomerService();

        let instanceIds = store.getters["instance/chosenInstanceIds"];
        instanceIds = instanceIds.length > 0 ? instanceIds : [values[0].instance_id]
        let valueWithCustomer = values[0] ? JSON.parse(JSON.stringify(values[0])) : null;

        values.forEach(item => {
            cService.insert(item.customer)
            delete item.customer
        })

        if (
            socket &&
            !valueWithCustomer.customer.is_favorite &&
            store.state.AppActiveUser.role.name !== 'administrador' &&
            Number(store.state.settings.settings.older_inbox_chats_obligatorie_in_first)
        ) {
            let where = {
                inbox: 1,
                finished_ticket: 0,
                instance_id: { in: instanceIds }
            };

            const { userDepartment } = store.state.AppActiveUser;
            const department =  !userDepartment ? 0 : undefined;
            if (department === 0) where['inbox_department_id'] = department;

            let count = await connection.count({
                from: this.tableName,
                where: where
            })

            if (count >= 1) {
                values[0].pickableInboxChat = false;
            }
        }

        let inserted = await connection.insert({
            into: this.tableName,
            values: values,
            upsert: true
        });

        if (inserted > 0) {
            if ( !firstLoad ) {
                Vue.$events.fire('RefreshQueryObservable', false);
            }
            if ( socket ){
                values.forEach(item => {
                    Vue.$events.fire('SumOfTickets', {type: 'insert', data: item})
                })
            }
        }

        if (
            !!values[0]
            && !firstLoad
            && !!values[0].customerLastChat
            && !!values[0].customerLastChat.hash
            && values[0].user_id === store.state.AppActiveUser.id
            && values[0].customerLastChat.hash.search('start') >= 0
        ) {
            Vue.$events.fire('ResetActiveUser');
            Vue.$events.fire('UpdateActiveChatUser', valueWithCustomer);
        }
    }
    
    async transferChat(value) {
        let chatTicket = (await connection.select({
            from: this.tableName,
            where: { id: value.chatTicket.id },
            limit: 1
        }))[0] || null;

        if ( !chatTicket ) {
            chatTicket = (await chatContact.infosChat(value.chatTicket.id))['data']['data']['chatTicketInfos'] || null;

            if ( !chatTicket ) return;

            if ( !chatTicket.inbox_department_id || (
                !!chatTicket.inbox_department_id
                && ( store.state.AppActiveUser.role.name === 'administrador' || (
                  store.state.AppActiveUser.userDepartment && store.state.AppActiveUser.userDepartment.id === chatTicket.inbox_department_id
                ))
            )) {
                await this.removeAndInsert([chatTicket], false);
            }
        }

        if ( value.chatTicket.user_id && value.chatTicket.user_name ){
            if (
                chatTicket.user !== null && chatTicket.user.name !== undefined
            ) {
                chatTicket.user.id = value.chatTicket.user_id;
                chatTicket.user.name = value.chatTicket.user_name;
                chatTicket.user.image = value.chatTicket.user_image;
            } else {
                chatTicket.user = {
                    id: value.chatTicket.user_id,
                    name: value.chatTicket.user_name,
                    image: value.chatTicket.user_image,
                    deleted_at: null
                }
            }
        } else { chatTicket.user = null; }

        let updated = await connection.update({
            in: this.tableName,
            set: {
                user: chatTicket.user,
                inbox: Number(value.inbox),
                user_id: value.chatTicket.user_id,
                createdAt: value.chatTicket.createdAt
            },
            where: { id: value.chatTicket.id }
        });

        await this.setPickable();

        if (updated > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
            Vue.$events.fire('TransferredChat', value.chatTicket);
            Vue.$events.fire('SumOfTickets', {type: 'transfer', data: value.chatTicket})
        }
    }
    
    async setPickable() {
        const { userDepartment, role } = store.state.AppActiveUser;
        const instanceIds = store.getters["instance/chosenInstanceIds"];
        const { older_inbox_chats_obligatorie_in_first, older_inbox_chats_first_only, priority_tickets_in_passive_flow } = store.state.settings.settings;

        const oldestPriority = !!parseInt(priority_tickets_in_passive_flow);
        const oldestFirst = !!parseInt(older_inbox_chats_first_only) || !!parseInt(older_inbox_chats_obligatorie_in_first);

        if (
            !instanceIds
            || role.name === 'administrador'
            || !Number(older_inbox_chats_obligatorie_in_first)
        ){ return true; }

        let ordination = [{ by: 'Customer.is_favorite', type: 'desc' }];
        if (oldestFirst && oldestPriority) {
            ordination.push(...[
                { by: 'ChatTickets.createdAt', type: 'asc' },
                { by: 'ChatTickets.priority', type: 'desc' }
            ]);
        } else if (oldestPriority) {
            ordination.push({ by: 'ChatTickets.priority', type: 'desc' });
        } else {
            ordination.push({ by: 'ChatTickets.createdAt',  type: 'asc' });
        }

        let where = {
            inbox: 1,
            finished_ticket: 0,
            instance_id: { in: instanceIds }
        };

        const department =  !userDepartment ? 0 : undefined;
        if (department === 0) where['inbox_department_id'] = department;

        const query = {
            from: this.tableName,
            join: {
                with: 'Customer',
                type: 'inner',
                on: "ChatTickets.customer_id = Customer.id",
                as: {
                    'id': 'customer.id',
                    'name': 'customer.name',
                    'phone_number': 'customer.phone_number',
                    'image': 'customer.image',
                    'is_blacklisted': 'customer.is_blacklisted',
                    'is_blacklisted_campaign': 'customer.is_blacklisted_campaign',
                    'open_field': 'customer.open_field',
                },
                where: { is_favorite: 0 }
            },
            order: ordination,
            where: where,
            limit: 11
        };

        if (oldestFirst) {
            query.order.unshift({by: 'ChatTickets.customer_id', type: 'asc'});
        }

        let selects = await connection.select(JSON.parse(JSON.stringify(query)));

        if (selects.length > 0) {
            await connection.update({
                in: this.tableName,
                set: { pickableInboxChat: true },
                where: { id: selects[0].id }
            });

            delete selects[0];

            for (const ticket of selects) {
                if (ticket) {
                    await connection.update({
                        in: this.tableName,
                        set: { pickableInboxChat: false },
                        where: { id: ticket.id }
                    });
                }
            }
        }
    }

    async closeTicket(value) {
        let updated = await connection.update({
            in: this.tableName,
            set: {
                inbox: 0,
                finished_ticket: 1,
                is_finishing: false,
                finished_at: value.finished_at
            },
            where: {
                id: value.id
            }
        });

        Vue.$events.fire('SumOfTickets', {type: 'removed', data: value})

        if (updated > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }
    
    async closingTicket(value) {
        let updated = await connection.update({
            in: this.tableName,
            set: {
                is_finishing: true,
            },
            where: {
                id: value
            }
        });
        if (updated > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }

    async updateLastMsg(value, sock = false) {
        let chatTicket = (await connection.select({
            from: this.tableName,
            where: { id: value.chat_ticket_id },
            limit: 1
        }))[0] || null;

        if ( sock && value && !chatTicket && !value.recovered && value.type === 1 && store.getters["instance/chosenInstanceIds"].includes(value.instance_id) ) {
            const queriedChatTicket = (await chatContact.infosChat(value.chat_ticket_id))['data']['data']['chatTicketInfos'] || null;
            if ( !queriedChatTicket ) return;

            if ( queriedChatTicket.user_id === store.state.AppActiveUser.id ) {
                await this.removeAndInsert([queriedChatTicket], false).then(async () => {
                    chatTicket = (await connection.select({
                        from: this.tableName,
                        where: { id: value.chat_ticket_id },
                        limit: 1
                    }))[0] || null;
                })
            }
        }

        if ( chatTicket ) {
            const lastDate = new Date(chatTicket.last_msg);
            const newDate = new Date(value.sent_at);
            if ( lastDate.getTime() > newDate.getTime() ) {
                return;
            }
        }

        await connection.update({
            in: this.tableName,
            set:{
                last_msg: value.sent_at,
                customerLastChat: this.mountLastChat(value)
            },
            where: {
                id: value.chat_ticket_id
            }
        })
    }

    async findTickets(ids = [], refresh = false) {
        if (!ids || ids.length === 0 ) {
            return;
        }

        for ( const id of ids ) {
            const hasIn = !!(await connection.count({
                from: this.tableName,
                where: { id: id }
            }));

            if ( hasIn ){
                continue;
            }

            const chatTicket = (await chatContact.infosChat(id))['data']['data']['chatTicketInfos'] || null;

            if ( !chatTicket ) {
                continue;
            }

            if ( !chatTicket.inbox_department_id || (
                  !!chatTicket.inbox_department_id
                  && ( store.state.AppActiveUser.role.name === 'administrador' || (
                        store.state.AppActiveUser.userDepartment && store.state.AppActiveUser.userDepartment.id === chatTicket.inbox_department_id
                  ))
            )) {
                await this.removeAndInsert([chatTicket], refresh);
            }
        }
    }
    
    mountLastChat(value) {
        return {
            document_mimetype: value.document_mimetype,
            document_name: value.document_name,
            id: value.id,
            is_bot_message: value.is_bot_message,
            is_temp: 0,
            message: value.message,
            sent_at: value.sent_at,
            tag_type: value.tag_type,
            type: value.type,
            chatTicket: {
                id: value.chat_ticket_id,
                is_research: value.chat_ticket !== undefined ? value.chat_ticket.is_research : false
            }
        }
    }
    
    async updateUnseenMsg(value) {
        await connection.update({
            in: this.tableName,
            set: {
                unseenMsg: {
                    '+': 1
                },
                customerLastChat: value,
            },
            where: {
                id: value.chat_ticket_id
            }
        })
    }
    
    async resetUnseenMsg(value) {
        await connection.update({
            in: this.tableName,
            set: {
                unseenMsg: 0,
            },
            where: {
                id: value
            }
        })
    }
    
    async updateTicket(value) {
        let updated = await connection.update({
            in: this.tableName,
            set:{
                priority: Number(value.priority),
                is_campaign: Number(value.is_campaign),
                open_by_template: Number(value.open_by_template),
                last_cost_created_at: value.last_cost_created_at
            },
            where: {
                id: value.id
            }
        })
        if (updated > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
            Vue.$events.fire('SumOfTickets', {type: 'updated', data: value})
        }
    }
    
    async updateResearch(value) {
        let updated = await connection.update({
            in: this.tableName,
            set:{
                is_research: Number(value.is_research),
                is_finishing: value.is_finishing
            },
            where: {
                id: value.id
            }
        })
        if (updated > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }
    
    async removeChatTicket(value) {
        let deleted = await connection.remove({
            from: this.tableName,
            where: { id: value.id }
        })

        Vue.$events.fire('SumOfTickets', {type: 'removed', data: value})

        if (deleted > 0) {
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }
    
    async clearTable(instanceIds, currentTab = null) {
        if ( !currentTab ){
            return await connection.remove({
                from: this.tableName,
                where: { instance_id: { in: instanceIds } }
            })
        }

        if ( !['inbox', 'my_chats'].includes(currentTab) ){
            return;
        }

        let closed = {
            inbox: 0,
            finished_ticket: 1,
            instance_id: { in: store.getters["instance/chosenInstanceIds"] }
        };

        let open = {
            inbox: 0,
            finished_ticket: 0,
            instance_id: { in: store.getters["instance/chosenInstanceIds"] }
        };

        const { id } = store.state.AppActiveUser;
        if ( currentTab === 'my_chats' ) open['user_id'] = {"!=": id}

        const ticketsClosed = await this.getChatTicketsByTab(closed, 250, null, null, 0, 0, 11);
        const ticketsOpen = await this.getChatTicketsByTab(open, 250, null, null, 0, 0, 15);
        const ticketIds = [...ticketsClosed.map(ticket => ticket['id']), ...ticketsOpen.map(ticket => ticket['id'])];

        if ( ticketIds.length > 0 ){
            const ccService = new CustomerChatService();
            await ccService.clearTable([], ticketIds)
            await connection.remove({
                from: this.tableName,
                where: { id: { in: ticketIds } }
            });
        }
    }
    
    async getCountChatActive() {
        return await connection.count({
            from: this.tableName,
            where: {
                instance_id: {in: store.getters["instance/chosenInstanceIds"]},
                finished_ticket: 0,
                is_research:0,
                user_id: store.state.AppActiveUser.id
            }
        })
    }
    
    async updatePickable(instance) {
        if (Number(store.state.settings.settings.older_inbox_chats_first)) {
            let ctUpdate = await connection.select({
                from: this.tableName,
                join: {
                    with: 'Customer',
                    type: 'inner',
                    on: "ChatTickets.customer_id = Customer.id",
                    as: {
                        'id': 'customer.id',
                        'name': 'customer.name',
                        'phone_number': 'customer.phone_number',
                        'image': 'customer.image',
                        'is_blacklisted': 'customer.is_blacklisted',
                        'open_field': 'customer.open_field',
                    },
                    where: {
                        is_favorite: 0,
                    },
                },
                where: {
                    inbox: 1,
                    finished_ticket: 0,
                    instance_id: instance
                },
                order: [
                    {
                        by: 'ChatTickets.createdAt',
                        type: 'asc'
                    }
                ],
                limit: 1
            });

            if (ctUpdate.length > 0) {
                await connection.update({
                    in: this.tableName,
                    set: {
                        pickableInboxChat: true
                    },
                    where: {
                        id: ctUpdate[0].id
                    }
                })
            }
        }
    }

    async updateBotIsActive( value, type = 'updated' ) {
        const updated = await connection.update(
            {
                in: this.tableName,
                set:{
                    bot_is_active: Number( value.bot_is_active )
                },
                where: {
                    id: value.id
                }
            }
        );

        if ( updated > 0 ) {

            if ( type === 'updated' ) {
                
                const [ chatTicket ] = await connection.select(
                    {
                        from: this.tableName,
                        where: {
                            id: value.id
                        },
                        limit: 1
                    }
                );

                if ( chatTicket ) {
    
                    Vue.$events.fire('SumOfTickets',
                        {
                            type: type,
                            data: chatTicket
                        }
                    );
    
                }

            }

            Vue.$events.fire('RefreshQueryObservable', false);

        }
    }
}
